import { request } from "@didi/webx-js";

const API_HOST = "https://api.udache.com/gulfstream/confucius";
const API_POP_LIST = "/api/privacy/app/popList";
const API_SIGN = "/api/privacy/app/sign";

const myRequest = (method, url, params, header, otherOptions) => {
  return request(method, API_HOST + url, {
    data: {
      ...params,
    },
    header,
    ...otherOptions,
  });
};

/**
 * 获取待签署隐私协议列表
 * @param {*} params
 * @returns
 */
export function getPopList(params) {
  return myRequest("get", API_POP_LIST, params);
}

/**
 * 签署隐私协议
 * @param {*} params
 * @returns
 */
export function postSign(params) {
  return myRequest('post', API_SIGN, params);
}
